import { eChannelType } from 'src/providers/SocketsProvider/Sockets.enums';
import { eIntegrationStatus } from 'src/providers/IntegrationsProvider/Integrations.enums';
import { tChannelDisplayName } from './NoConnectionBanner.types';

export type tDisconnectedBannerConfig = {
  channel: eChannelType;
  name: tChannelDisplayName;
  integrationState: eIntegrationStatus;
  onReconnect: () => void;
  showReconnectButton: boolean;
  // Opt-in predicate: when false, the banner is suppressed even if the
  // integration state looks disconnected. WA Web uses this to hide the banner
  // on workspaces that never installed a WA Web account (BUG-468). Channels
  // that omit it default to true, preserving existing behavior.
  isApplicable?: boolean;
};

export function selectDisconnectedBannerConfig(
  configs: tDisconnectedBannerConfig[],
  chatChannel: eChannelType | undefined,
): tDisconnectedBannerConfig | null {
  if (!chatChannel) return null;
  const match = configs.find(
    (c) =>
      c.channel === chatChannel &&
      c.integrationState !== eIntegrationStatus.CONNECTED &&
      (c.isApplicable ?? true),
  );
  return match ?? null;
}
